import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { hideModal, getAgeGroupDiv } from "../../util/utility";
import moment from 'moment';

export default class ConfirmationModal extends Component {


    closeModal = () => {
        const modal = document.getElementById("availability-close-confirmation");
        hideModal(modal);
    }

    render() {
        return (
            <div id="availability-close-confirmation" className="modal fade" role="dialog" aria-labelledby="myModalLabel"
                aria-hidden="true">
                <div className="vertical-alignment-helper">
                    <div className="modal-dialog vertical-align-center">
                        <div className="modal-content">
                            <div className="modal-header" style={{ margin: "5px auto" }}>
                                <h5 className="font-weight-bold">Are you sure you want to end availability?</h5>
                            </div>
                            <div className="modal-footer">
                                <div className="row" style={{ marginTop: 50, margin: "0 auto", justifyContent: "center" }}>
                                    <div className="col-5">
                                        <button className="btn btn-outline-primary"
                                            onClick={() => this.closeModal()} >
                                            CANCEL
                                                </button>
                                    </div>
                                    <div className="col-5">
                                        <button className="btn btn-primary" onClick={()=> this.props.submitCloseAvailability()}>
                                            YES
                                                </button>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}